module.exports = __webpack_public_path__ + "static/media/icon-arrow-right-ios.ee3ca68f.svg";